export interface Certification {
	canAccess?: boolean;
	code: string;
	description: string;
	id: string;
	logoUrl: string;
	name: string;
	cityCertification?: CityCertification;
}

export interface CityCertification {
	certificationStatus: "INCOMPLETE" | "IN_AUDIT" | "COMPLETED" | "FILLING";
	cityId?: string;
	id: string;
}

export interface CityCertificationResume {
	areas: CityCertificationResumeAreas[];
	certificationCode: string;
	certificationLevel: 'BRONZE' | 'SILVER' | 'GOLD' | 'PLATINUM';
	certificationName: string;
	cityCertificationId: string;
	filledPercentage: number;
	totalEssentialIndicatorsFilled: number;
	totalIndicators: number;
	totalSupportIndicatorsFilled: number;
}

export interface CityCertificationResumeAreas {
	certificationAreaId: "ECONOMY" | "EDUCATION" | "ENERGY" | "ENVIRONMENT_AND_CLIMATE_CHANGE" | "FINANCE" | "GOVERNANCE" |
		"HEALTH" | "HOUSING" | "POPULATION_AND_SOCIAL_CONDITIONS" | "RECREATION" | "SAFETY" | "SOLID_WASTE" | "SPORT_AND_CULTURE" |
		"TELECOMMUNICATION" | "TRANSPORT" | "LOCAL_OR_URBAN_AGRICULTURE_AND_FOOD_SECURITY" | "URBAN_PLANNING" | "SEWERS" | "WATER";
	indicators: Indicator[];
	areaImgUrl: string;
	totalEssentialIndicators: number;
	totalEssentialIndicatorsFilled: number;
	totalSupportIndicators: number;
	totalSupportIndicatorsFilled: number;
}

export interface Indicator {
	certificationArea: "ECONOMY" | "EDUCATION" | "ENERGY" | "ENVIRONMENT_AND_CLIMATE_CHANGE" | "FINANCE" | "GOVERNANCE" |
		"HEALTH" | "HOUSING" | "POPULATION_AND_SOCIAL_CONDITIONS" | "RECREATION" | "SAFETY" | "SOLID_WASTE" | "SPORT_AND_CULTURE" |
		"TELECOMMUNICATION" | "TRANSPORT" | "LOCAL_OR_URBAN_AGRICULTURE_AND_FOOD_SECURITY" | "URBAN_PLANNING" | "SEWERS" | "WATER";
	certificationType: "SUPPORT" | "ESSENTIAL";
	formula: string;
	unity: string;
	id: string;
	evidenceModelUrl: string;
	indicatorInfo: SaveIndicator;
	hasNumeratorAndDenominator: boolean;
	name: string;
	description: string;
	refCode: string;
	year: number;
	validationType: 'NUMBER' | 'PERCENTAGE' | 'FLOAT_VALUE' | 'POSITIVE_PERCENTAGE' | 'POSITIVE_DOUBLE' | 'POSITIVE_NUMBER' |
		'DOUBLE_BETWEEN_ZERO_ONE' | 'POSITIVE_FLOAT' | 'ZERO_ONE' | 'PERCENTAGE_POSITIVE_DOUBLE' | 'MONETARY_VALUE' |
		'NUMBER_LOWER_100' | 'PERCENTAGE_POSITIVE_FLOAT' | 'NEGATIVE_DOUBLE' | 'NEGATIVE_FLOAT' | 'NEGATIVE_NUMBER' |
		'MBER_BETWEEN_MINUS100_AND_100';
}

export interface SaveIndicator {
	evidences: Evidence[];
	evidencesABNT: EvidenceAbnt[];
	links: string[];
	moreInformation: string;
	value: string | number;
	indicatorId: string;
	abntId: string;
	status: IndicatorStatus;
}

export interface Evidence {
	fileUrl: string;
	originalFileName: string;
}

export interface EvidenceAbnt {
	abntUrl?: string;
	description: string;
	evidenceId: number;
	evidenceType: EvidenceAbntType;
	link: string;
	originalFileName: string;
  url?: string;
	ncDescription?: string;
}

export enum EvidenceAbntType {
	LINK = 'LINK',
	DOCUMENT = 'DOCUMENT'
}

export enum IndicatorStatus {
	IN_FILLING = 'IN_FILLING',
	FILLED = 'FILLED',
	ABSTENTION = 'ABSTENTION',
	COMPLIANT = 'COMPLIANT',
	NON_CONFORMING = 'NON_CONFORMING',
	WAITING = 'WAITING',
}

export interface CertificationAreaResponse {
	indicator: Indicator;
	resume: CityCertificationResumeAreas;
}

export enum CertificationArea {
	ECONOMY = 'Economia',
	EDUCATION = 'Educação',
	ENERGY = 'Energia',
	ENVIRONMENT_AND_CLIMATE_CHANGE = 'Meio Ambiente e mudanças climáticas',
	FINANCE = 'Finanças',
	GOVERNANCE = 'Governança',
	HEALTH = 'Saúde',
	HOUSING = 'Habitação',
	POPULATION_AND_SOCIAL_CONDITIONS = 'População e Condições Sociais',
	RECREATION = 'Recreação',
	SAFETY = 'Segurança',
	SOLID_WASTE = 'Resíduos sólidos',
	SPORT_AND_CULTURE = 'Esporte e cultura',
	TELECOMMUNICATION = 'Telecomunicação',
	TRANSPORT = 'Transporte',
	LOCAL_OR_URBAN_AGRICULTURE_AND_FOOD_SECURITY = 'Agricultura local/urbana e segurança alimentar',
	URBAN_PLANNING = 'Planejamento urbano',
	SEWERS = 'Esgotos',
	WATER = 'Água',
}
